<template>
    <div>
        <div class="top_texts">
            <h3 style="margin-bottom: 0">Aanvullende gegevens</h3>
        </div>
        <div>
            <h4 style="margin-top: 0; padding-top: 0; font-weight: normal">
                Voor hoeveel filialen wilt u een overeenkomst afsluiten?
            </h4>
        </div>
        <div>
            <div
                v-for="(location, index) in contract.location_info"
                :key="index"
                class="row_container"
            >
                <div style="width: calc(50% + 40px)">
                    <div class="form-group">
                        <label :for="'location_name_' + index">Plaatsnaam</label>
                        <div>
                            <input
                                :id="'location_name_' + index"
                                type="text"
                                class="pull-left"
                                v-model="location.place"
                                style="width: calc(100% - 40px)"
                            />
                            <button
                                class="btn btn-danger pull-right"
                                style="margin-top: 2px"
                                @click="remove_location_info(index)"
                            >
                                X
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row_container" style="margin-top: 15px; margin-bottom: 15px">
                <button
                    class="btn btn-primary"
                    style="margin-left: 8px"
                    @click="add_location_info_row"
                >
                    Filiaal toevoegen
                </button>
            </div>
            <div class="row_container">
                <div style="width: 100%; float: left">
                    <div class="form-group">
                        <label>
                            Wat is de gewenste ingangsdatum?
                            <span v-if="contract.start_date_type === 'fixed'">
                U kunt de datum niet wijzigen.
              </span>
                            <span
                                v-else-if="contract.start_date_type === 'future_first_of_month'"
                            >
                De datum moet in de toekomst liggen en de eerste van de maand
                zijn.
              </span>
                            <span v-else-if="contract.start_date_type === 'future'">
                De datum moet in de toekomst liggen.
              </span>
                        </label>
                        <div style="width: 50%">
                            <datepicker
                                v-model="contract.start_date"
                                :full-month-name="true"
                                :language="nl"
                                :monday-first="true"
                                :disabled-dates="disabled_dates"
                                :input-class="{ error: $v.contract.start_date.$error }"
                            ></datepicker>
                        </div>
                    </div>
                </div>
                <div style="clear: both"></div>
            </div>
        </div>
        <div style="margin-top: 15px; margin-bottom: 100px">
            <button
                class="btn btn-default pull-left"
                @click="$emit('prev_step')"
                :class="{ 'is-disabled': working }"
            >
                Vorige stap
            </button>
            <button
                class="btn btn-primary pull-right"
                @click="next_step"
                :class="{ 'is-disabled': working }"
            >
                Volgende stap
                <span v-if="working">
          <font-awesome-icon
              :icon="['fal', 'spinner']"
              spin
          ></font-awesome-icon>
        </span>
            </button>
        </div>
        <form>
            <input
                id="current_location_input"
                name="current_location_input"
                type="text"
                v-model="current_location_input"
            />
        </form>
    </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import {nl} from "vuejs-datepicker/dist/locale";

const start_date_validation = (value, vm) => {
    return true;
    console.debug("Validating", value);
    if (!value) {
        console.error("No start date");
        return false;
    }

    const start_date = new Date(value);
    const now = new Date();

    // The following block is kept here for how funny it is:
    // const now_ymd = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}`;
    // const start_ymd =
    // `${start_date.getFullYear()}-${start_date.getMonth()}-${start_date.getDate()}`;
    // if (start_ymd < now_ymd) {
    //     console.error('String comparison fails');

    if (start_date <= now) {
        console.error(
            "Start date too early:",
            start_date,
            "(choice) vs",
            now,
            "(now)"
        );
        return false;
    }

    if (
        vm.start_date_type === "future_first_of_month" &&
        start_date.getDate() !== 1
    ) {
        console.error("Start date must be on first of month");
        return false;
    }

    console.info("Start date", start_date, "is valid");
    return true;
};

export default {
    components: {
        Datepicker,
    },
    props: {
        contract: {},
        working: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            nl: nl,
            current_location_input: null,
        };
    },
    validations: {
        contract: {
            start_date() {
                return true;
            }
            // start_date: { x: (() => true) },
        },
    },
    computed: {
        disabled_dates() {
            const self = this;

            const dates = {
                to: new Date(), // Disable everything in the past.
            };

            if (self.contract.start_date_type === "fixed") {
                dates.customPredictor = (date) =>
                    date !== new Date(self.contract.start_date);
            }

            if (self.contract.start_date_type === "future_first_of_month") {
                dates.customPredictor = (date) => date.getDate() !== 1;
            }

            return dates;
        },
    },
    methods: {
        next_step() {
            console.info('Submitting')
            const self = this;

            if (self.current_location_input) {
                // Honey pot trap
                console.info('No steppy into the honeypotje pl0x')
                return;
            }

            self.$v.$reset();
            self.$v.$touch();

            if (self.$v.$invalid) {
                console.error('Invalid formz')
                return;
            }

            self.$emit("next_step");
            console.info('Emitting next step')
        },
        add_location_info_row() {
            const self = this;

            self.contract.location_info.push({
                place: "",
                number: "",
            });
        },
        remove_location_info(index) {
            const self = this;

            const new_list = [];
            self.contract.location_info.forEach((item, i) => {
                if (parseInt(index, 10) !== parseInt(i, 10)) {
                    new_list.push(item);
                }
            });

            self.contract.location_info = new_list;
        },
    },
};
</script>

<style scoped="scoped">
#current_location_input {
    position: fixed;
    left: -100%;
}
</style>
